






























import { Component, Mixins } from 'vue-property-decorator';
import BalanceIntegrationMixin from '@/mixins/vue/BalanceIntegrationMixin';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import NemCardWallet from '@/components/settings/wallet/NemCardWallet.vue';
import WalletFAQ from '@/components/settings/wallet/WalletFAQ.vue';
import copy from 'copy-to-clipboard';

@Component({
    components: {
        NemCardWallet,
        WalletFAQ,
    },
})
export default class Wallet extends Mixins(IsMobileMixin, BalanceIntegrationMixin) {
    public created() {
        this.integrateBalanceFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });
    }
}
